const unseenNoticeCount = state => state.unseenNoticeCount;

export default unseenNoticeCount;
